import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { Button, message, Upload, UploadFile } from "antd";
import React, { useEffect } from "react";
import { UploadOutlined } from "@ant-design/icons";

interface ImageItem {
  uid: string;
  name: string;
  status: string;
  url: string;
  rank: number;
}

type Props = {
  imageList: ImageItem[];
  setImageList: React.Dispatch<React.SetStateAction<ImageItem[]>>;
  setFieldValue: (field: string, value: any) => void;
};

const DragImages: React.FC<Props> = ({
  imageList,
  setImageList,
  setFieldValue,
}) => {
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;

    setImageList((prevList) => {
      const reorderedImages = Array.from(prevList);
      const [removed] = reorderedImages.splice(result.source.index, 1);
      reorderedImages.splice(result.destination.index, 0, removed);

      const updatedImages = reorderedImages.map((image, index) => ({
        ...image,
        rank: index + 1,
      }));

      console.log(updatedImages);

      return updatedImages;
    });
  };

  useEffect(() => {
    setFieldValue(
      "images",
      imageList.map((img, index) => ({
        path: img.url,
        rank: img.rank ?? index + 1, // Əgər rank yoxdursa, indeksə uyğun təyin et
      }))
    );
  }, [imageList, setFieldValue]);

  const handleRemoveImage = (uid: any) => {
    const updatedList = imageList.filter((item) => item.uid !== uid);
    const updatedListWithRanks = updatedList.map((image, index) => ({
      ...image,
      rank: index + 1,
    }));

    setImageList(updatedListWithRanks);
  };

  const getBase64 = (file: File, callback: (base64: string) => void) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => callback(reader.result as string);
    reader.onerror = () => message.error("Faylı yükləmək alınmadı.");
  };

  const handleFileUpload = (file: any) => {
    getBase64(file, (base64: string) => {
      setImageList((prevList) => {
        const maxRank = Math.max(...prevList.map((img) => img.rank), 0);
        const newImage = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: base64,
          rank: maxRank + 1,
        };
        const newList = [...prevList, newImage];
        setFieldValue(
          "images",
          newList.map((img) => ({ path: img.url, rank: img.rank }))
        );
        return newList;
      });
    });
    return false;
  };

  return (
    <div className="form_input">
      <div className="input_wrapper">
        <div>
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="images" direction="horizontal">
              {(provided) => (
                <div
                  className="image-container"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {imageList.map((image, index) => (
                    <Draggable
                      key={image.uid}
                      draggableId={image.uid}
                      index={index}
                    >
                      {(provided) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className="image-item"
                          style={{
                            ...provided.draggableProps.style,
                            margin: "10px 5px",
                            marginTop: "40px",
                            display: "inline-block",
                          }}
                        >
                          <img
                            src={image.url}
                            alt={image.name}
                            style={{
                              width: "100px",
                              height: "100px",
                              objectFit: "cover",
                            }}
                          />
                          <span
                            onClick={() => handleRemoveImage(image.uid)}
                            style={{
                              marginLeft: "10px",
                              color: "red",
                              fontSize: "12px",
                              fontWeight: "bold",
                              cursor: "pointer",
                            }}
                          >
                            <i className="fa-solid fa-x"></i>
                          </span>
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        <Upload
          name="images"
          multiple
          fileList={imageList.map((img) => ({
            uid: img.uid,
            name: img.name,
            status: img.status as UploadFile["status"],
            url: img.url,
          }))}
          beforeUpload={handleFileUpload}
          showUploadList={false}
        >
          <Button icon={<UploadOutlined />}>Digər şəkilləri seçin</Button>
        </Upload>
      </div>
    </div>
  );
};

export default DragImages;
